<template>
  <div>
    <v-toolbar dense flat>
      <v-flex xs8>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search date / time / rider name / cash "
          single-line
          hide-details
          style="padding: 0"
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-select
          v-model="search_by_status"
          single-line
          hide-details
          style="padding: 0"
          prepend-icon="search"
          label="Search status request"
          :items="status_list"
        ></v-select>
      </v-flex>
    </v-toolbar>
    <requestCashForm
      :dialog="requestCashDialog"
      @setDialog="requestCashDialog = $event"
      :item_detais="item_detais"
    />
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="filterRequest"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ request_cash.indexOf(props.item) + 1 }}
        </td>
        <td>{{ props.item.rider_province_th }}</td>
        <td>{{ props.item.date }}</td>
        <td class="text-xs-center">{{ props.item.time }}</td>
        <td>{{ props.item.mt_user_id }}</td>
        <td class="text-xs-right">
          {{
            props.item.mt_total_money
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>

        <td v-if="props.item.mt_type == 1" class="text-xs-center">
          <v-btn
            :ripple="false"
            small
            depressed
            color="blue lighten-4"
            class="style-status"
            >แจ้งโอนเงิน</v-btn
          >
        </td>
        <td v-else-if="props.item.mt_type == 26" class="text-xs-center">
          <v-btn
            :ripple="false"
            small
            depressed
            color="green lighten-4"
            class="style-status"
            >สแกน QR</v-btn
          >
        </td>
        <td v-else class="text-xs-center">
          <v-btn
            :ripple="false"
            small
            depressed
            color="deep-purple lighten-4"
            class="style-status"
            >ขอถอนเงิน</v-btn
          >
        </td>
        <td
          class="text-xs-center"
          :style="{
            color:
              props.item.mt_approve == 0
                ? 'orange'
                : props.item.mt_approve == 1
                ? 'green'
                : 'red',
          }"
          v-if="props.item.mt_type == 26"
        >
          {{
            props.item.mt_approve == 0
              ? "Unpaid"
              : props.item.mt_approve == 1
              ? "Paid"
              : "Cancel"
          }}
        </td>
        <td
          class="text-xs-center"
          :style="{
            color:
              props.item.mt_approve == 0
                ? 'orange'
                : props.item.mt_approve == 1
                ? 'green'
                : 'red',
          }"
          v-else
        >
          {{
            props.item.mt_approve == 0
              ? "Pending"
              : props.item.mt_approve == 1
              ? "Approve"
              : "Cancel"
          }}
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn
              icon
              @click="viewRequestCash(props.item, props.index)"
              slot="activator"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false" class="text-xs-center">
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
    <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import requestCashForm from "./RequestCashForm";
import { mapState, mapGetters } from "vuex";
export default {
  // props:['request_cash'],
  data: () => ({
    status_list: [
      {
        text: "All",
        value: 99,
      },
      {
        text: "Pending",
        value: 0,
      },
      {
        text: "Approve",
        value: 1,
      },
      {
        text: "Cancel",
        value: 2,
      },
    ],
    search_by_status: 99,
    search: "",
    loading_message: false,
    requestCashDialog: false,
    dialog: false,
    item_detais: {},
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "num",
      },
      {
        text: "Province",
        align: "center",
        value: "rider_province_th",
        sortable: false,
      },
      {
        text: "Date",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Time",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        value: "mt_user_id",
        sortable: false,
      },
      {
        text: "Cash",
        align: "center",
        value: "mt_total_money",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "type",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
  }),
  components: {
    requestCashForm,
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      request_cash: "fetchCashRider/getRequestCashTable",
    }),
    pages() {
      this.pagination.totalItems = this.request_cash.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filterRequest() {
      if (this.search_by_status == 99) {
        return this.request_cash;
      } else {
        return this.request_cash.filter((val) => {
          return val.mt_approve == this.search_by_status;
        });
      }
    },
  },
  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchCashRider/getCashReqest");
    this.loading_message = false;
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    viewRequestCash(item, index) {
      this.item_detais = item;
      this.requestCashDialog = true;
    },
  },
};
</script>

<style scoped>
.style-status {
  border-radius: 20px;
}
</style>
